/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRingtone = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M15 2v2h4v2h-4v11c0 2.757-2.243 5-5 5s-5-2.243-5-5 2.243-5 5-5c1.125 0 2.164.373 3 1.003V2zm-5 12c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgRingtone as Ringtone };
